$(function () {
    const setCustomerConfirmDelivered = (orderId) => {
      return $.promisedAjax({
          url: `/orders/customerConfirmDelivered`,
          type: 'POST',
          data: JSON.stringify({"orderId": orderId}),
          contentType: 'application/json',
          dataType: 'json'
        }).then((res) => {
          return res;
        })
        .catch((err) => {
          return err;
          console.error('Unable to set Customer Confirm Delivered', err);
        })
    };

    $('body').on('change', `[id^="order-slider-rating-"], [id^="delivery-slider-rating-"], [id^="order-rating-desc-"], [id^="temperature-of-food-rating-"]`, (e) => {
      const { id,value } = e.target;
      const $this = $(e.target);
      const orderId = parseInt($this.data("order-id"));
      if(id.includes('order-slider-rating-')){
        sessionStorage.setItem(id, value);
      }
    });

    /**
     * Get user order ratings from DOM
     */
    const getUserOrderRatings = (orderId) => {
        let ratingDescription = "";
        const userDescriptionVal = ( $(`#order-rating-desc-${orderId}`).val() ) ? $(`#order-rating-desc-${orderId}`).val().trim() : '';
        const ratingValue = $(`#order-slider-rating-${orderId}`).val();
        const temperatureOfFood = $(`#temperature-of-food-rating-${orderId}`).val();
        const deliveryRatingValue = $(`#delivery-slider-rating-${orderId}`).val(); //timing of delivery
        if (typeof userDescriptionVal === "string") ratingDescription = userDescriptionVal;
        return {ratingValue, deliveryRatingValue, ratingDescription, temperatureOfFood};
    };

    /**
     * Submit user order ratings
     */
    const submitUserOrderRatings = (data) => {
        return $.promisedAjax({
            type: 'POST',
            url: `/ratings/submit/order`,
            contentType: 'application/json',
            data: JSON.stringify(data),
            dataType: 'json'
          })
    };

    /**
     * Submit user order ratings
     */
    const updateOrderRatings = (data) => {
      return $.promisedAjax({
          type: 'POST',
          url: `/orders/rating/order`,
          contentType: 'application/json',
          data: JSON.stringify(data),
          dataType: 'json'
        })
  };

    /**
     * Retrieve the orde details for given orderId
     * @param {Number} orderId
     */
    const getOrderDetails = (orderId) => {
        const url = `/orders/details/user?orderId=${orderId}&res="json"`
        return $.promisedAjax({
            url: url,
            contentType: 'application/json',
            dataType: 'json'
          }).then(response => {
            if (response.data) {
                const parsedOrderDetails = $.objectKeysToCamelCase(response.data);
                parsedOrderDetails.items = parseOrderItems(parsedOrderDetails.items);
                return parsedOrderDetails;
            }
            return null;
          })
    };

    /**
     * Parse orderDetails items
     * @param {Array} orderItems
     */
    const parseOrderItems = (orderItems) => {
        return orderItems.map((item, idx) => {
            //We parsed the item_id to entryId because this how item Ids are being referenced
            //on the ratings and menuItems collections
            return {
                "entryId": item.item_id,
                "name": item.item_name,
                "menuName": item.section_name,
                "sectionName": item.section_name,
                "orderId": item.order_id,
                "price": item.retail_price,
                "description": item.description,
                "rating": item.rating
            }
        })
    };

    /**
     * Submit request to to rate the order items and redirect to ratings page
     * @param {Array} items
     * @param {String} venueId
     * @param {String} venueName
     */
    const rateOrderItems = (orderItems, venueId, venueName, orderId, userId) => {
        const encodedVenueName = encodeURIComponent(venueName);
        const ratingUrl = "/ratings/edit";
        const $redirectForm = $(`#checkout-redirectForm-${orderId}`);
        let ratingItems = [];
        orderItems.forEach(function(item){
          let data = {
            item : item.entryId,
            addon: null
          };
          ratingItems.push(data);
        });

        $redirectForm.append(
          $('<input>', {
            name: 'orderId',
            value: orderId,
            type: 'hidden'
          }),
          $('<input>', {
            name: 'venueId',
            value: venueId,
            type: 'hidden'
          }),
          $('<input>', {
            name: 'items',
            value: JSON.stringify(ratingItems),
            type: 'hidden'
          })
        );
        $redirectForm.submit();
    };
})
